/**
 * Swiper
 * Created by zdy on 2018/12/05.
 */
import { StyleSheet } from 'react-native';

import { pt } from '../../../../common/utils';

export default StyleSheet.create({
    container: {},
    unit_wrap: {
        height: pt(142),
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    pic_wrap: {
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        overflow: 'hidden',
        shadowOffset: { width: 5, height: 5 },
        shadowColor: 'black',
        shadowOpacity: 0.2,
        shadowRadius: 1
    },
    pic: {
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        resizeMode: 'contain',
        width: '100%',
        height: '100%'
    }
});
